import {Fragment, useEffect, useState} from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
import {Link, redirect, useNavigate} from "react-router-dom";
import { API_ENDPOINTS} from "../config";
import {useDivision} from "../context/DivisonContext";

const initialNavigation = [
    { name: 'Dashboard' ,href: '/dashboard', current: false },
    { name: 'Job form', href: '/job-form/en/', current: false },
    { name: 'Job form new', href: '/job-form-new/en', current: false },
    { name: 'Reference form', href: '/reference-form', current: false},
    { name: 'Blog form', href: '/blog-form', current: false}
    // { name: 'Operations support form', href: '/operations-support-form', current: false}
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}


export default function NavBar() {

    const {division} = useDivision();
    const[navigation, setNavigation] = useState(initialNavigation);

    useEffect(() => {
        let filteredNavigation = initialNavigation.filter(item => item.name === 'Dashboard');

            switch (division){
                case 'Marketing':
                    filteredNavigation = [...filteredNavigation, {name: 'Blog form', href:'/blog-form', current: false}]
                    break;
                case 'Sales':
                    filteredNavigation = [...filteredNavigation, {name: "Reference form", href: "/reference-form", current: false}]
                    break;
                case 'HR':
                    filteredNavigation = [...filteredNavigation, {name: "Job form new", href: '/job-form-new/en', current: false}]
                    break;
                default:
                    break;
            }

        console.log("Setting FilteredNavigation to => ", filteredNavigation);
        setNavigation(filteredNavigation);

    }, [division]);

    const navigate = useNavigate();


    const LogOut = () => {
        localStorage.removeItem('token');
        navigate("/");
    }


    const homeNavigation = () => {
        navigate("/");
    }

    return (
        <>
            <div className="min-h-full">
                <Disclosure as="nav" className="bg-white">
                    {({ open }) => (
                        <>
                            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                                <div className="flex h-16 items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0">
                                            <Link to={'/dashboard'}>
                                                <img
                                                    className="h-8 w-auto"
                                                    src="https://static.wixstatic.com/media/9d90f3_e5e08befbf554451a60099a1e5907fbc~mv2.png"
                                                    alt="CUREosity"
                                                    onClick={() => {
                                                        homeNavigation()
                                                    }}
                                                />
                                            </Link>
                                        </div>
                                        <div className="hidden md:block">
                                            <div className="ml-10 flex items-baseline space-x-4">
                                                {navigation.map((item) => (
                                                    <Link
                                                        key={item.name}
                                                        to={item.href}
                                                        className={classNames(
                                                            item.current
                                                                ? 'bg-green-700 text-white'
                                                                : 'text-gray-900 hover:bg-green-900 hover:text-white',
                                                            'rounded-md px-3 py-2 text-sm font-medium'
                                                        )}
                                                        aria-current={item.current ? 'page' : undefined}
                                                    >
                                                        {item.name}
                                                    </Link>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"Logout Button"}>
                                        <button onClick={() => {LogOut();}} className={'text-gray-900 hover:bg-blue-900 hover:text-white ' +
                                            'rounded-md px-3 py-2 text-sm font-medium'}>Log-out
                                        </button>
                                    </div>
                                    <div className="-mr-2 flex md:hidden">
                                        {/* Mobile menu button */}
                                        <Disclosure.Button
                                            className="relative inline-flex items-center justify-center rounded-md bg-gray-50 p-2 text-green-700 hover:bg-gray-100 hover:text-green-700 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                                            <span className="absolute -inset-0.5"/>
                                            <span className="sr-only">Open main menu</span>
                                            {open ? (
                                                <XMarkIcon className="block h-6 w-6" aria-hidden="true"/>
                                            ) : (
                                                <Bars3Icon className="block h-6 w-6" aria-hidden="true"/>
                                            )}
                                        </Disclosure.Button>
                                    </div>
                                </div>
                            </div>

                            <Disclosure.Panel className="md:hidden">
                                <div className="space-y-1 px-2 pb-3 pt-2 sm:px-3">
                                    {navigation.map((item) => (
                                        <Link
                                            key={item.name}
                                            as="a"
                                            to={item.href}
                                            className={classNames(
                                                item.current ? 'bg-green-900 text-white' : 'text-gray-900 hover:bg-green-700 hover:text-white',
                                                'block rounded-md px-3 py-2 text-base font-medium'
                                            )}
                                            aria-current={item.current ? 'page' : undefined}
                                        >
                                            {item.name}
                                        </Link>
                                    ))}
                                </div>
                                <div className="border-t border-gray-700 pb-3 pt-4">
                                </div>
                            </Disclosure.Panel>
                        </>
                    )}
                </Disclosure>
            </div>
        </>
    )
}

